import styled from 'styled-components';
import {
  space,
  flexbox,
  grid,
  layout,
  position,
  SpaceProps,
  LayoutProps,
  FlexboxProps,
  GridProps,
  PositionProps,
} from 'styled-system';

export interface ContainerProps
  extends SpaceProps,
    LayoutProps,
    FlexboxProps,
    PositionProps,
    GridProps {
  addInputMargin?: boolean;
  opacity?: string;
  testId?: string;
}

export const Container = styled.div.attrs((props: ContainerProps) => ({
  'data-testid': props.testId || props['data-testid'],
}))<ContainerProps>`
  ${space}
  ${layout}
  ${flexbox}
  ${grid}
  ${position}
  ${({ addInputMargin }) =>
    addInputMargin &&
    `
    && > * {
      margin-bottom: 24px;
    }
  `}
  opacity: ${props =>
    props.theme.opacities[props.opacity ?? 'high'] || props.opacity}
`;
